/**
 * config/features.js
 * Module visibility flags for the library-first pivot (2026-08).
 *
 * These hide WHOLE PRODUCT MODULES that still exist end-to-end — routes,
 * components, API endpoints, and DataStore rows are all untouched. Nothing is
 * deleted: flip a flag back to `true`, rebuild, and the module returns exactly
 * as it was. The EOL decision is deliberately deferred.
 *
 * Why hardcoded constants and not REACT_APP_* env vars: CRA bakes env vars at
 * build time, so an env flag still needs a rebuild + redeploy to flip — it buys
 * nothing over a source constant, and it costs reviewability (a boolean flip
 * shows up in the PR diff) and safety (no prod env drift silently un-hiding a
 * module).
 *
 * Backend API routes are deliberately NOT gated — every meetings/gamification
 * route already carries requireAuth plus role guards, so hiding the UI changes
 * nothing about who is authorised. See the ADR for the full reasoning.
 *
 * TO EOL A MODULE: `grep -rn "FEATURES\." client/src` prints every deletion
 * site. This file is the inventory.
 *
 * Note if you re-enable these independently: the QR check-in token generator
 * lives in the admin Meetings tab, so GAMIFICATION-on with SCHEDULING-off
 * leaves no way to mint new check-in tokens.
 */
export const FEATURES = {
  // Meetings, calendar, slot booking, meeting detail, admin Meetings tab,
  // and the meeting/slot fields in admin Settings.
  SCHEDULING: false,

  // Leaderboard, points, attendance, QR check-in, and the points fields in
  // admin Settings.
  GAMIFICATION: false,

  // The Coaching tab: solo analyze (upload / record / URL) plus the session
  // history folded into it, and the /history/:id session detail page.
  // Does NOT affect the AI coaching report on club speeches — that renders via
  // CoachingReport inside ClubSpeechDetail and is independent of this flag.
  COACHING: false,
};

export default FEATURES;
